import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=6981794f&scoped=true"
import script from "./PromotionForm.vue?vue&type=script&lang=js"
export * from "./PromotionForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=6981794f&prod&scoped=true&lang=scss"
import style1 from "./PromotionForm.vue?vue&type=style&index=1&id=6981794f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981794f",
  null
  
)

export default component.exports